import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

/** True when the org is flagged as a staffing company. */
export function useIsStaffing(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.is_staffing)
  );
}
